<template>
  <div id="listWidget" class="mb-4">
    <div class="instruction-card card-item mb-3">
      <div class="instruction-header">
        <i class="fa-solid fa-wifi me-2 text-primary"></i>
        <span class="instruction-title">{{ props.step }}. Wifi 설정</span>
      </div>
      <div class="instruction-body">
        <div class="instruction-step">
          <div class="instruction-step-number">1</div>
          <div class="instruction-step-content">
            <span>연결된 조명제어기에 현재 위치의 Wifi
              <strong class="text-primary">SSID</strong>와
              <strong class="text-primary">비밀번호</strong>를 입력해주세요.</span>
          </div>
        </div>
        <div class="instruction-step">
          <div class="instruction-step-number">2</div>
          <div class="instruction-step-content">
            <span>아래의 <strong class="text-primary">등록 버튼</strong>을 눌러 연결된 조명제어기에
              입력된 Wifi 정보를 설정해주세요. Wifi 정보가 다르면 제대로 동작하지
              않습니다.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ControllerCard 사용 -->
    <ControllerCard
      v-if="props.controller && props.controller._id"
      :controller="props.controller"
      controller-type="조명제어기"
      mode="wizard"
      class="mb-3"
    />

    <!-- WiFi 입력 폼 (카드 형태) -->
    <div class="instruction-card card-item mb-3">
      <div class="instruction-header">
        <i class="fa-solid fa-network-wired me-2 text-primary"></i>
        <span class="instruction-title">Wifi 정보 입력</span>
      </div>
      <div class="instruction-body">
        <div class="mb-3">
          <label class="form-label mb-1 fw-normal">SSID</label>
          <input
            type="text"
            class="form-control form-control-lg fs-15px"
            placeholder="SSID를 입력해주세요."
            :value="ssid"
            @change="onSsidChange"
          />
        </div>
        <div>
          <label class="form-label mb-1 fw-normal">비밀번호</label>
          <input
            type="text"
            class="form-control form-control-lg fs-15px"
            placeholder="비밀번호를 입력해주세요."
            :value="password"
            @change="onPasswordChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, getCurrentInstance } from 'vue';
import Card from '@/common/template/components/bootstrap/Card.vue';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import ControllerCard from '../ControllerCard.vue';

const { logger } = getCurrentInstance().appContext.config.globalProperties;
const props = defineProps([
  'controller',
  'ssid',
  'password',
  'step',
  'handleSsidChange',
  'handlePasswordChange',
]);
const ssid = ref(props.ssid);
const password = ref(props.password);

const onSsidChange = (e) => {
  ssid.value = e.target.value;
  if (props.handleSsidChange) {
    props.handleSsidChange(e.target.value);
  }
};

const onPasswordChange = (e) => {
  password.value = e.target.value;
  if (props.handlePasswordChange) {
    props.handlePasswordChange(e.target.value);
  }
};
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.instruction-step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.instruction-step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}

.instruction-step-content .text-primary {
  color: #0d6efd;
  font-weight: 600;
}
</style>
